import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { MiDetailFields } from "@miplatform/components";
import { INPUT_TYPES, PLATFORM_MODULES } from "@miplatform/constants";
import { ConfigAccordionHeader } from "../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IOrderTemplateForm } from "../ConfigOrderTemplates.types";

export const OrderWorkflowTimingTabView: FC<
  OrderWorkflowTimingTabViewProps
> = ({ form, extraTabProps: { isReadOnly } = {} }) => {
  const { control, watch, setValue } = form;
  const {
    requiresApproval,
    requiresConfirmation,
    approvalLeadDays,
    approvalLeadTime,
    confirmationLeadDays,
    confirmationLeadTime,
    module,
  } = watch();

  const isDisabled = module === PLATFORM_MODULES.MI_DISPATCH || isReadOnly;

  const workFlowFields = [
    {
      label: "Approval Required",
      name: "requiresApproval",
      formControl: control,
      fieldType: INPUT_TYPES.SWITCH,
      width: "100%",
      disabled: isDisabled,
    },
    {
      label: "Approval Lead Days",
      name: "approvalLeadDays",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      required: requiresApproval,
      value: approvalLeadDays,
      suffix: " day(s)",
      decimalScale: 0,
      error: requiresApproval && !approvalLeadDays,
      helperText:
        requiresApproval &&
        !approvalLeadDays &&
        "Approval Lead Days is required when approval is required",
      disabled: isDisabled,
      InputProps: { inputProps: { maxLength: 11 } },
      setValue: (value: string) => {
        setValue("approvalLeadDays", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
    },
    {
      label: "Approval Lead Time",
      name: "approvalLeadTime",
      formControl: control,
      fieldType: INPUT_TYPES.TIME,
      required: requiresApproval,
      error: requiresApproval && !approvalLeadTime,
      helperText:
        requiresApproval &&
        !approvalLeadTime &&
        "Approval Lead Time is required when approval is required",
      disabled: isDisabled,
    },
    {
      label: "Confirmation Required",
      name: "requiresConfirmation",
      formControl: control,
      fieldType: INPUT_TYPES.SWITCH,
      width: "100%",
      disabled: isDisabled,
    },
    {
      label: "Confirmation Lead Days",
      name: "confirmationLeadDays",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      required: requiresConfirmation,
      value: confirmationLeadDays,
      suffix: " day(s)",
      decimalScale: 0,
      error: requiresConfirmation && !confirmationLeadDays,
      helperText:
        requiresConfirmation &&
        !confirmationLeadDays &&
        "Confirmation Lead Days is required when confirmation is required",
      disabled: isDisabled,
      InputProps: { inputProps: { maxLength: 11 } },
      setValue: (value: string) => {
        setValue("confirmationLeadDays", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
    },
    {
      label: "Confirmation Lead Time",
      name: "confirmationLeadTime",
      formControl: control,
      fieldType: INPUT_TYPES.TIME,
      required: requiresConfirmation,
      error: requiresConfirmation && !confirmationLeadTime,
      helperText:
        requiresConfirmation &&
        !confirmationLeadTime &&
        "Confirmation Lead Time is required when confirmation is required",
      disabled: isDisabled,
    },
  ];

  return (
    <ConfigAccordionHeader title="Workflow Timing">
      <MiDetailFields detailFields={workFlowFields} />
    </ConfigAccordionHeader>
  );
};

interface OrderWorkflowTimingTabViewProps {
  form: UseFormReturn<IOrderTemplateForm>;
  extraTabProps?: {
    isReadOnly?: boolean;
  };
}
